/* Quantity radios submit through Impact's existing product form. No cart interception. */
(() => {
  if (customElements.get('evolved-quantity-offers')) return;
  customElements.define('evolved-quantity-offers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = document.getElementById(this.dataset.form);
      if (!form) return;
      form.addEventListener('product:rerender', event => {
        const updated = event.detail.htmlFragment.querySelector('#' + CSS.escape(this.id));
        if (!updated) return;
        const currentChoices = [...this.querySelectorAll('.ev-quantity-offers__choice')];
        const nextChoices = [...updated.querySelectorAll('.ev-quantity-offers__choice')];
        currentChoices.forEach((choice, index) => {
          const next = nextChoices[index];
          if (!next) return;
          choice.querySelector('input').disabled = next.querySelector('input').disabled;
          for (const selector of ['[data-offer-prices]', '[data-offer-saving]']) {
            choice.querySelector(selector).replaceWith(next.querySelector(selector).cloneNode(true));
          }
        });
        this.ensureSelection();
      }, {signal:this.controller.signal});
      this.ensureSelection();
    }
    ensureSelection() {
      if (!this.querySelector('input:checked:not(:disabled)')) {
        const available = this.querySelector('input:not(:disabled)');
        if (available) available.checked = true;
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();
